import React from "react";
import ShareCapital from "components/CompanyDashboard/MaintainYourCompany/Changes/ShareCapital";

const ShareInformation = (props) => {
  const isInManualUpdate = true;
  return (
    <>
      <ShareCapital
        handleGoBack={props.handleGoBack}
        handleGoForward={props.handleGoForward}
        isInManualUpdate={isInManualUpdate}
      />
    </>
  );
};

export default ShareInformation;
